import formedit from './formedit';
import formquery from './formquery';
import wrapper from './wrapper';
import modal from './modal';
import log from './log';
import upload from './upload';
import mutiUpload from './mutiUpload'
import erpSkuInput from './erpskuinput'
import photoLog from './photolog'
import LabelSelect from './labelselect';
import MultipleSelect from './multipleselect';
export default function init(Vue) {
    Vue.component('compFormEdit', formedit);
    Vue.component('compFormQuery', formquery);
    Vue.component('compWrapper', wrapper);
    Vue.component('compModal', modal);
    Vue.component('compLog', log);
    Vue.component('compUpload', upload);
    Vue.component('compMutiUpload', mutiUpload);
    Vue.component('compErpSkuInput', erpSkuInput);
    Vue.component('compPhotoLog', photoLog);
    Vue.component('compLabelSelect', LabelSelect);
    Vue.component('compMultipleSelect', MultipleSelect);
    
}